import React, { Component } from 'react'
import _ from 'lodash/'

export class SearchInput extends Component{
    
    searchConversations = _.debounce( async (keyword) => {
        
        this.props.searchConversations(keyword);

    }, 800)


    render (){

        const { t } = this.props;
        
        return (
            <div className="chat-search">
                <input disabled={this.props.disabled} onKeyUp={(e) => this.searchConversations(e.target.value)} placeholder={t('messenger_search')} className="chat-search-input"/>
                <img src={require('../../images/icon-search.png')}/>
            </div>
        )

    }

}

export default SearchInput